import { css } from "@emotion/react";

export const containerStyle = css`
  @media only screen and (max-width: 992px) {
    margin-top: 104px;
  }
`;

export const headerStyle = css`
  display: flex;
  justify-content: space-between;
  height: 131px;
  line-height: 22px !important;
`;

export const titleStyle = css`
  margin-bottom: 13px !important;
  font-size: 20px !important;
  line-height: 22px !important;
  display: inline-block;
`;

export const iconStyle = css`
  width: 20px;
  height: 20px;
  margin-right: 8px;
  vertical-align: top;
`;

export const contentStyle = css`
  background-color: #ffffff;
  padding: 24px;
  margin-left: 24px;
  margin-right: 24px;
  height: calc(100vh - 215px);
  overflow: auto;
`;

export const footerStyle = css`
  margin-top: 24px;
  border-top: 1px solid #e3e3e4;
`;

export const toolbarStyle = css`
  width: 100%;
`;
